// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-routes-home-index-js": () => import("./../src/routes/Home/index.js" /* webpackChunkName: "component---src-routes-home-index-js" */)
}

